import { composeReducers } from 'common/util/composeReducers';

import { ACTIONS } from 'common/actions/applicationHeader';

export function addApplicationHeaderTitle(state, action) {
    if (!action || action.type !== ACTIONS.ADD_APPLICATION_HEADER_TITLE) {
        return state;
    }

    const app = { ...state.app };
    const { title } = action.payload;
    app.pageTitle = title;

    return {
        ...state,
        app
    };
}

export function clearApplicationHeaderTitle(state, action) {
    if (!action || action.type !== ACTIONS.CLEAR_APPLICATION_HEADER_TITLE) {
        return state;
    }

    const app = { ...state.app };
    app.pageTitle = null;
    return {
        ...state,
        app
    };
}

export function setHeaderLoadingState(state, action) {
    if (!action || action.type !== ACTIONS.SET_HEADER_LOADING_STATE) {
        return state;
    }

    const { loadingText } = action.payload;

    return {
        ...state,
        headerLoadingText: loadingText
    };
}

export function clearHeaderLoadingState(state, action) {
    if (!action || action.type !== ACTIONS.CLEAR_HEADER_LOADING_STATE) {
        return state;
    }

    return {
        ...state,
        headerLoadingText: null
    };
}

export default composeReducers(
    addApplicationHeaderTitle,
    clearApplicationHeaderTitle,
    setHeaderLoadingState,
    clearHeaderLoadingState
);
